import { render, staticRenderFns } from "./BaseProgressBar.vue?vue&type=template&id=08fdb50f&scoped=true&"
import script from "./BaseProgressBar.vue?vue&type=script&lang=ts&"
export * from "./BaseProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseProgressBar.vue?vue&type=style&index=0&id=08fdb50f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fdb50f",
  null
  
)

export default component.exports